import * as React from "react";
import { QAPropsBase } from "../State";
import QuestionAnswer from "../answers/QuestionAnswer";
import { buttonChangeFn, changeFn } from "../store";
import { Form } from "semantic-ui-react";

// tslint:disable-next-line: interface-name
interface Props {
  questionAnswers: Array<QAPropsBase>;
    onChange?: changeFn;
    onSubmit: buttonChangeFn;
    isLoading: boolean;
    icon?: string;
}

const QuestionSet: React.FunctionComponent<Props> = (props: Props) => {
  return (
    <div className="quiz">
          {props.questionAnswers.map((qa, index) =>
              <QuestionAnswer key={index} index={index}
                  propsBase={{
                      answerContent: qa.answerContent,
                      answerPlaceholder: qa.answerPlaceholder,
                      answerType: qa.answerType,
                      answerValidator: qa.answerValidator,
                      errorProps: qa.errorProps,
                      isRequired: qa.isRequired,
                      label: qa.label,
                      answerValue: qa.answerValue,
                      isAnswered: qa.isAnswered,
                      isAnswerValid: qa.isAnswerValid,
                      showError: qa.showError,
                      questionContent: qa.questionContent,
                      propName: qa.propName,
                      answerAdditionalData: qa.answerAdditionalData
                  }}
                  onChange={props.onChange}
              />,
          )}
          {
              <div style={{ marginTop: "30px" }}>
                  <Form.Button loading={props.isLoading}
                      onClick={(e) => props.onSubmit(e)}
                      color="green" id="btnSubmit" type="submit" icon={props.icon}
                      content={"Submit"} value="Submit"
                      disabled={!(props.questionAnswers.every((a) => a.isAnswerValid) && props.questionAnswers.filter((a) => a.isRequired).every((b) => b.isAnswered))} />
              </div>
          }
    </div>
  );
};

export default QuestionSet;
